import React from "react";
import { useArticleComments } from "../Hooks/Comments/Article/useArticleComments";
import CommentsDiscussion from "./CommentsDiscussion";

export default function ArticleComments({ articleId }: { articleId: number }) {
    const controller = useArticleComments(articleId);
    return <CommentsDiscussion controller={controller} contentType="article" />;
}
